var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { createStyleParamGetter, StyleParamType, } from '@wix/tpa-settings';
import { FORM_FACTORS } from './helpers';
var cloneStyles = function (style) {
    return __assign(__assign({}, style), { styleParams: __assign(__assign({}, style.styleParams), { numbers: __assign({}, style.styleParams.numbers), booleans: __assign({}, style.styleParams.booleans), fonts: __assign({}, style.styleParams.fonts), colors: __assign({}, style.styleParams.colors) }) });
};
var overrideHostStyles = function (style, _a) {
    var _b;
    var stylesParams = _a.stylesParams, isMobile = _a.isMobile, isRTL = _a.isRTL;
    if (!style) {
        throw new Error('No `host.styles` was passed to Widget by the platform.');
    }
    if (!stylesParams) {
        return style;
    }
    // We should not mutate the original style object, since it's staying persistent between modes.
    style = cloneStyles(style);
    var getParam = createStyleParamGetter({
        storage: style.styleParams,
        colors: style.siteColors,
        textPresets: style.siteTextPresets,
        isRTL: isRTL,
        isMobile: isMobile,
    });
    var styleParamsMap = (_b = {},
        _b[StyleParamType.Number] = style.styleParams.numbers,
        _b[StyleParamType.Boolean] = style.styleParams.booleans,
        _b[StyleParamType.Font] = style.styleParams.fonts,
        _b[StyleParamType.Color] = style.styleParams.colors,
        _b);
    Object.keys(stylesParams).forEach(function (styleKey) {
        var styleParam = stylesParams[styleKey];
        var keyWithoutTraits = styleParam.key || styleParam.name;
        var value = getParam(styleParam);
        if (value && keyWithoutTraits) {
            var targetStylesMap = styleParamsMap[styleParam.type];
            targetStylesMap[keyWithoutTraits] = value;
        }
    });
    return style;
};
export var withWidgetStylesOverrides = function (Widget, _a) {
    var stylesParams = _a.stylesParams;
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _a;
            var _this = _super.call(this, props) || this;
            _this.isMobile = function (props) {
                var _a;
                var formFactor = (_a = props === null || props === void 0 ? void 0 : props.host) === null || _a === void 0 ? void 0 : _a.formFactor;
                if (formFactor) {
                    return formFactor === FORM_FACTORS.MOBILE;
                }
                return !!props._mobile;
            };
            _this.state = {
                style: overrideHostStyles((_a = props.host) === null || _a === void 0 ? void 0 : _a.style, {
                    stylesParams: stylesParams,
                    isMobile: _this.isMobile(props),
                    isRTL: !!props._isRTL,
                }),
            };
            return _this;
        }
        class_1.prototype.componentDidUpdate = function (prevProps) {
            var _a;
            if (prevProps.host !== this.props.host) {
                this.setState({
                    style: overrideHostStyles((_a = this.props.host) === null || _a === void 0 ? void 0 : _a.style, {
                        stylesParams: stylesParams,
                        isMobile: this.isMobile(this.props),
                        isRTL: !!this.props._isRTL,
                    }),
                });
            }
        };
        class_1.prototype.render = function () {
            return (React.createElement(Widget, __assign({}, this.props, { 
                // There is a bug for Editor-X, where formfactor for controller is not correct.
                // So as a workaround, we can override `_mobile` prop passed from controller with value
                // taken from props.host.formFactor, since it's a correct value.
                // The next line can be removed after platform will fix it.
                _mobile: this.isMobile(this.props), style: this.state.style })));
        };
        return class_1;
    }(Component));
};
//# sourceMappingURL=withWidgetStylesOverrides.js.map